import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { KeycloakContext } from "./KeycloakContext";
export const FixKeycloakUrl = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const keycloak = useContext(KeycloakContext);
    const accountConsolePathname = new URL(keycloak.createAccountUrl()).pathname + "/";
    useEffect(() => {
        if (location.pathname.includes("&")) {
            const correctedPath = location.pathname.replace("&", "?");
            navigate(correctedPath, { replace: true });
        }
        // This is a workaround, because Keycloak appends these action parameters to the URL hash, but can't handle
        // them properly and redirects to the error page when we keep the hash.
        if (window.location.pathname === accountConsolePathname
            && (window.location.hash === "#kc_action=UPDATE_PASSWORD"
                || window.location.hash === "#kc_action=webauthn-register"
                || window.location.hash === "#kc_action=download_client_certificate")
            || window.location.hash === "#kc_action=request_client_certificate") {
            if (window.location.hash === "#kc_action=request_client_certificate") {
                window.location.hash = "#client-certificate";
            }
            else {
                window.location.hash = "";
            }
        }
        // We do this because anchor links were misused in Keycloak to pass action parameters
        // As we know want to simulate the *regular* anchor link behavior here, we need to look at the URL
        // We'll also have to clear the URL hash as Keycloak recognizes the anchor link as an action parameter,
        // but it doesn't know the action "client-certificate" and therefore redirects to the error page.
        // (Also, depending on whether the URL contains parameters or not,
        // the pathname may or may not have a trailing slash.)
        const accountConsolePathnameNoTrailingSlash = new URL(keycloak.createAccountUrl()).pathname;
        const isPotentialCandidateForAnchorLinkFix = window.location.pathname === accountConsolePathname ||
            window.location.pathname === accountConsolePathnameNoTrailingSlash;
        if (isPotentialCandidateForAnchorLinkFix
            && window.location.hash === "#client-certificate") {
            window.location.hash = "";
            setTimeout(() => {
                const element = document.getElementById("client-certificate");
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        }
    }, [location, navigate]);
    return null;
};
